import { render, staticRenderFns } from "./SellerDescription.vue?vue&type=template&id=0629c510&"
import script from "./SellerDescription.vue?vue&type=script&lang=js&"
export * from "./SellerDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports